import $ from "jquery"
import _ from "underscore"
import {bindActionCreators} from "redux"
import messageResource from "../messageResource"
import PageMediator from "../PageMediator"
import * as StoreUtils from "../store/StoreUtils"
import TaskManagementStore from "./TaskManagementStore"
import CustomerProjectSelection from "../CustomerProjectSelection"
import TasksTable from "./tasksTable/TasksTable"
import CustomersProjectsPanel from "./customersProjectsPanel/CustomersProjectsPanel"
import CustomerPanelController from "../panels/customer/CustomerPanelController"
import ProjectPanelController from "../panels/project/ProjectPanelController"
import CustomerStore from "../store/CustomerStore"
import ProjectStore from "../store/ProjectStore"
import TaskStore from "../store/TaskStore"
import PageOverlayTipsManager from "../tips/PageOverlayTipsManager"
import LoadingMoire from "../LoadingMoire"
import makeRpcCall from "../util/jquery_rpc"
import {CustomersProjectsSelectionQualifier} from "../constants"
import ScrollUtils from "../util/ScrollUtils"
import KanbanViewContainer from "./kanban/components/KanbanViewContainer"
import {
    addNewTasks,
    addTasks,
    archiveProjectAndReloadTasks,
    archiveProjectsOfCustomerAndReloadTasks,
    changeCPSelection,
    changeSingleCPSelectionAction,
    changeTaskNameFilterAction,
    removeCustomer,
    removeProject,
    removeTasks,
    setHasManageableTasks,
    setManagementAssignments,
    setRecentlyCreatedCustomers,
    setRecentlyCreatedProjects,
    setViewerSettings,
    toggleLoadingMoire,
} from "./common/actions"
import {getBulkOperationProgress} from './bulkOperations/selectors'
import {addCustomers, addProjects, setTypesOfWorkList, setWorkflowStatusesList} from "../entities/actions"
import {
    getFilterCPSelection,
    getIntersectedCPSelection,
    getSingleCPSelection,
    getTaskNameFilter,
    getTaskStatusFilter,
    getViewMode, isPossibleToAddTasks,
    isShowOnlyManageableTasks,
} from "./common/selectors"
import {getTasksSorting, isNeedToReloadTasks as isNeedToReloadTableTasks} from './tasksTable/selectors'
import {addLoadedTaskIds, changeAllTasksSelectedAction, setLoaded as setTasksTableLoaded, setLoadedTaskIds} from './tasksTable/actions'
import {setLoaded as setKanbanLoaded} from './kanban/actions'
import {TASK_LOAD_LIMIT, TaskManagementViewMode} from "./constants"
import HeaderPanel from "./header/HeaderPanel"
import BulkOperationsContainer from './bulkOperations/Container'
import {connect} from "../redux/utils"
import {getCustomers, getProjects, getWorkflowStatuses} from "../entities/selectors"
import {getOpenTaskId} from "../panels/task/editPanel/selectors"
import LoadTasksFromCSVManager from '../addNewTasks/LoadTasksFromCSVManager'
import TaskManagementPage from './Page'
import {getLoggedInUser} from '../loggedInUser/selectors'
import CreateTasksPopupController from '../addNewTasks/CreateTasksPopupController'
import CreateProjectPopupController from './createLightbox/project/CreateProjectPopupController'
import CreateCustomerPopupController from './createLightbox/customer/CreateCustomerPopupController'
import {openProjectPanel} from '../panels/project/actions'
import {openCustomerPanel} from '../panels/customer/actions'
import CreateTaskPanelContainer from '../panels/task/createPanel/CreateTaskPanelContainer'
import {openEditTaskPanel} from '../panels/task/editPanel/actions'
import {createdTasksToast, customerFromRpc, projectFromRpc, taskFromRpc} from './utils'
import {toast} from '../toasts/utils'
import {copyTasksToProjectsAction} from './bulkOperations/actions'
import {changedTaskWorkflowStatus} from '../entities/tasks/actions'
import BulkOperationProgress from './bulkOperations/components/BulkOperationProgress'
import {isTWSEnabled, isWASEnabled} from '../features/selectors'
import PageFeatureDiffController from './components/PageFeatureDiffController'
import SelectionController from './taskSelection/SelectionController'
import {changeTaskSelected} from './taskSelection/actions'
import {getSelectedTaskIds} from './taskSelection/selectors'
import {isShowLoadingMoire} from './loadingMoire/selectors'
import {setEnabledFeatures} from '../features/actions'
import EditTaskPanelContainer from './components/EditTaskPanelContainer'
import {
    CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION,
    CUSTOMER_UNAVAILABLE_EXCEPTION,
    NO_SUCH_CUSTOMER_EXCEPTION,
    NO_SUCH_PROJECT_EXCEPTION,
    NO_SUCH_TASK_EXCEPTION,
    NO_SUCH_WORKFLOW_STATUSES_EXCEPTION,
    PROJECT_CANNOT_BE_MODIFIED_EXCEPTION,
    PROJECT_IS_ARCHIVED_EXCEPTION,
    PROJECT_IS_NOT_ASSIGNED_EXCEPTION,
    PROJECT_IS_NOT_AVAILABLE_EXCEPTION,
    TASK_CANNOT_BE_MODIFIED_EXCEPTION,
    TASK_ESTIMATE_DISABLED_EXCEPTION,
    TASK_UNAVAILABLE_EXCEPTION,
    WORKFLOW_STATUS_CHANGED_EXCEPTION,
    WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION,
    WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION
} from './common/ExceptionsTypes'
import TaskManagementPageOverlayTipsManager from '../tips/managers/TaskManagementPageOverlayTipsManager'
import UrlHelper from '../panels/urlHelper'

export class TaskManagementMediator extends PageMediator {
    constructor({
        data,
        openTaskPanel = taskId => {},
        openProjectPanel = projectId => {},
        openCustomerPanel = customerId => {},
        addNewTasks = tasks => {},
        changeSelectAllTasks = (isAll) => {},
        changeTaskSelected = (id, selected) => {},
        changeTaskNameFilterAction = () => {},
        changeSingleCPSelectionAction = () => {},
        changeCPSelection = () => {},
        addCustomers = () => {},
        addProjects = () => {},
        addTasks = () => {},
        setTypesOfWork = () => {},
        setTasksTableLoaded = () => {},
        setKanbanLoaded = () => {},
        setManagementAssignments = () => {},
        setViewerSettings = () => {},
        setHasManageableTasks = () => {},
        removeTasks = () => {},
        removeProject = () => {},
        removeCustomer = () => {},
        setRecentlyCreatedCustomers = () => {},
        setRecentlyCreatedProjects = () => {},
        setWorkflowStatusesList = () => {},
        copyTasksToProjectsAction = () => {},
        archiveProjectsOfCustomer = () => {},
        archiveProject = () => {},
        changedTaskWorkflowStatus = () => {},
        setLoadedTaskIds = () => {},
        addLoadedTaskIds = () => {},
        toggleLoadingMoire = () => {},
        updateEnabledFeatures = () => {},
    }) {
        super()

        this.data = data

        this.actions = {
            changeTaskSelected,
            changeSelectAllTasks,
            openTaskPanel,
            openProjectPanel,
            openCustomerPanel,
            changeTaskNameFilterAction,
            addNewTasks,
            changeSingleCPSelectionAction,
            changeCPSelection,
            addCustomers,
            addProjects,
            addTasks,
            setTypesOfWork,
            setTasksTableLoaded,
            setKanbanLoaded,
            setManagementAssignments,
            setViewerSettings,
            setHasManageableTasks,
            removeTasks,
            removeProject,
            removeCustomer,
            setRecentlyCreatedCustomers,
            setRecentlyCreatedProjects,
            setWorkflowStatusesList,
            copyTasksToProjectsAction,
            archiveProjectsOfCustomer,
            archiveProject,
            changedTaskWorkflowStatus,
            setLoadedTaskIds,
            addLoadedTaskIds,
            toggleLoadingMoire,
            updateEnabledFeatures,
        }

        this.state = {
            viewMode: null,
            showLoadingMoire: false,
            bulkOperationProgress: 0,
            selectedTaskIds: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: [],
            },
            filterCustomerProjectSelection: {
                customers: [],
                projects: [],
                qualifier: CustomerProjectSelection.ALL,
                activeOnly: false,
            },
            singleCustomerProjectSelection: {
                customerId: null,
                projectId: null,
            },
            intersectedCustomerProjectSelection: {},
            taskNameFilter: '',
            workflowStatusesMap: {},
            tasksSorting: {
                by: '',
                asc: false,
            },
            isNeedToReloadTableTasks: false,
            taskIdWithDetailsOpen: null,
            viewerSettings: {
                hasEditHierarchyRight: false,
                hasAccessToAllManagementScope: false,
                canAccessCompleteTaskInformation: false
            },
            managementAssignments: {
                isAllScopeAssigned: false,
                customers: {},
                projects: {},
                tasks: {}
            },
            showOnlyManageableTasks: false,
            loggedInUser: null,
            twsEnabled: false,
            isWASEnabled: false,
            projects: {},
            customers: {},
            isPossibleToAddTasks: false,
        }

        this.onStatePropertyBecameTrue('isNeedToReloadTableTasks', () => this.loadTasks(true))

        this.onStatePropertyChanged("viewMode", viewMode => this._updateViewMode(viewMode))

        //TODO deprecated
        this.onStatePropertyChanged('selectedTaskIds', selectedTaskIds => {
            // synchronize with old store may be need to connect TaskTable with store
            TaskManagementStore.setTaskSelection({
                isAllSelected: false,
                selectedTasks: selectedTaskIds,
            })
        })

        this.onStatePropertyChanged('showLoadingMoire', (show) => {
            this.pageLoadingMoire.toggle(show);
        })

        this.onStatePropertyChanged('bulkOperationProgress', (progress) => {
            this.bulkProgress.setState({progress})
            this.bulkProgress.toggle(progress !== null)

        })

        this.onStatePropertyChanged('taskNameFilter', (taskNameFilter) => {
            TaskManagementStore.setTaskNameFilter(taskNameFilter)
        })
        this.onStatePropertyChanged('taskIdWithDetailsOpen', (taskId, prevTaskId) => {
            if (taskId !== null)
                $(document).trigger('taskManagement_task_startEditing', taskId)
            if (prevTaskId !== null)
                $(document).trigger('taskManagement_task_stopEditing', prevTaskId)
        })

        this.onAnyStatePropertyChanged(['viewerSettings', 'managementAssignments'], () => {
            this.projectPanelController.updatePanelManagementsAssignmentsState(this.state.viewerSettings, this.state.managementAssignments)
        })
    }

    getPage()
    {
        return this.page;
    }

    afterRender()
    {
        this.initStore();
        this.initComponents();
        this.subscribeToEvents();
    }

    initStore()
    {
        StoreUtils.mergeCustomersProjectsFromJSP(this.data);
        TaskManagementStore.setTaskStatusFilter(this.state.taskStatusFilter);
    }

    initComponents()
    {
        const self = this;

        PageOverlayTipsManager.setInstance(new TaskManagementPageOverlayTipsManager().init());

        new PageFeatureDiffController().init()

        this.page = new TaskManagementPage().init($("body"));
        this.customersProjectsPanel = new CustomersProjectsPanel({
            importTasksCb: () => this._showImportTasksPopup(),
            createNewTasksCb: () => this._showCreateTaskPopup(),
            createNewProjectCb: () => this._showCreateProjectPopup(),
            createNewCustomerCb: () => this._showCreateCustomerPopup(),
        }).init($(".cpTreeBlock"))

        this.page.adjustSize()

        const $taskListBlock = $("#taskListBlock");
        this.headerPanel = new HeaderPanel().init($taskListBlock);
        this.tasksTable = new TasksTable().init($taskListBlock);
        this.kanbanViewContainer = new KanbanViewContainer({}).init($taskListBlock);

        new BulkOperationsContainer({
            $pageEl: self.page.$el,
            $dialogsContainerEl: $(".taskListBlockWrapper"),
            $containerEl: $taskListBlock,
        }).init()

        new SelectionController().init()

        this.customerPanelController = new CustomerPanelController().init();

        $(this.customerPanelController).on("deleteBegin", function()
        {
            self.pageLoadingMoire.show();
        });
        $(this.customerPanelController).on("deleteEnd", function()
        {
            self.pageLoadingMoire.hide();
        });
        $(this.customerPanelController).on("hidePanel", function(e, data)
        {
            $(document).trigger("taskManagement_customerViewEnd", data.customerId);
            if (data.changed && CustomerProjectSelection.fromPlainObject(self.state.intersectedCustomerProjectSelection).includesCustomer(CustomerStore.get(data.customerId), true)){
                self.tasksTable.updateRows();
            }
        });

        new EditTaskPanelContainer({
            onTaskMovedCb: taskId => this.tasksTable.updateRow(taskId),
        }).init()

        new CreateTaskPanelContainer().init()

        this.projectPanelController = new ProjectPanelController().init();

        $(this.projectPanelController).on("projectCannotBeModified customerCannotBeModified", function()
        {
            self._updateAll();
        });

        $(this.projectPanelController).on("projectMoved", function(e, projectId)
        {
            self.actions.addProjects([projectId])
            if (self.state.singleCustomerProjectSelection.projectId === projectId)
            {
                const selection = {
                    customerId: ProjectStore.get(projectId).customerId,
                    projectId: projectId
                }
                self.actions.changeSingleCPSelectionAction(selection)
            }
        });
        $(this.projectPanelController).on("deleteBegin", function()
        {
            self.pageLoadingMoire.show();
        });
        $(this.projectPanelController).on("deleteEnd", function()
        {
            self.pageLoadingMoire.hide();
        });
        $(this.projectPanelController).on("hidePanel", function(e, data)
        {
            $(document).trigger("taskManagement_projectViewEnd", data.projectId);
            if (data.changed) {
                self.tasksTable.updateRows();
            }
        });

        this.loadTasksFromCSVManager = new LoadTasksFromCSVManager().init(
            this.data.importCsv.actionUrl,
            window.SystemSettings.csvSeparator,
            this.data.importCsv.errorCodes,
            this.data.importCsv.errorMessages,
            (projectIds) => self._onImportFromCsvCompleted(projectIds),
            ({customers, projects}) => {
                self.actions.addCustomers(customers)
                self.actions.addProjects(projects)
            },
            (typesOfWork) => {
                self.actions.setTypesOfWork(typesOfWork)
            },
        )
        PageOverlayTipsManager.getInstance().refreshDynamicTips();

        this.bulkProgress = new BulkOperationProgress()

        this.pageLoadingMoire = new LoadingMoire({
            innerContent: this.bulkProgress,
            additionalSpinnerSettings: {
                radius: 17,
                length: 13,
                width: 4
            },
            delay: 500
        }).init($('body'))

        this.createTasksPopupContorller = new CreateTasksPopupController({
            successTaskCreationCb: (res) => {
                this.actions.setWorkflowStatusesList(res.workflowStatuses)
                this._appendCreatedTasks(res)
            },
            serviceName: "TaskManagementService"
        })

        this.createProjectPopupController = new CreateProjectPopupController({
            createProjectSuccessCb: result => this._createProjectSuccess(result),
            createProjectFailureCb: result => this._createProjectFailure(result),
            setTypesOfWorkCb: this.actions.setTypesOfWork,
        })

        this.createCustomerPopupController = new CreateCustomerPopupController({
            createCustomerStartCb: () => this.actions.toggleLoadingMoire(true),
            createCustomerSuccessCb: result => this._onCreateCustomerSuccess(result),
            createCustomerFailureCb: () => this.actions.toggleLoadingMoire(false),
            copyTasksCb: this.actions.copyTasksToProjectsAction,
        })

        new UrlHelper({
            openCreateTaskPopup: () => {
                if(this.state.isPossibleToAddTasks) {
                    this.createTasksPopupContorller.showPopup()
                }
            }
        }).init()
    }

    subscribeToEvents()
    {
        const self = this;
        $(document).on("taskManagement_tasksTable_allCustomersClick taskManagement_tasksTable_allTasksClick " +
                       "taskManagement_customersProjectsPanel_allCustomersNode_select",
                       function()
                       {
                           const selection = {customerId: null, projectId: null}
                           self.actions.changeSingleCPSelectionAction(selection)
                       });
        $(document).on("taskManagement_tasksTable_customerClick", function()
        {
            const selection = {customerId: self.state.singleCustomerProjectSelection.customerId, projectId: null}
            self.actions.changeSingleCPSelectionAction(selection)
        });
        $(document).on("taskManagement_tasksTable_scrollToEnd", () => {
            if (!TaskManagementStore.isAllTasksLoaded()) {
                this.loadTasks(false)
            }
        })
        $(document).on("taskManagement_tasksTable_tasksSearchField_change", function(e, text)
        {
            TaskManagementStore.setTaskNameFilter(text);
            self.actions.changeTaskNameFilterAction(text)
        });
        $(document).on("taskManagement_tasksTable_taskRow_statusChange", function(e, changeData) {

            const workflowStatusBean = self.state.workflowStatusesMap[changeData.workflowStatusId]
            const workflowStatusEnabled = self.state.twsEnabled
            const method = workflowStatusEnabled
                ? 'TaskManagementService.updateTaskWorkflowStatus'
                : 'TaskManagementService.updateTaskStatus'

            const params = workflowStatusEnabled
                ? [changeData.taskId, workflowStatusBean.type, workflowStatusBean.id, workflowStatusBean.name, false]
                : [changeData.taskId, workflowStatusBean.type, false]
            self.updateTask(method, params, changeData.taskId);
        });
        $(document).on("taskManagement_tasksTable_taskRow_estimateChange", function(e, changeData)
        {
            self.updateTask("TaskManagementService.updateTaskEstimatedTime", [changeData.taskId, changeData.estimatedTime], changeData.taskId);
        });
        $(document).on("taskManagement_tasksTable_taskRow_deadlineChange", function(e, changeData)
        {
            self.updateTask("TaskManagementService.updateTaskDeadline", [changeData.taskId, changeData.deadline], changeData.taskId);
        });
        $(document).on("taskManagement_customersProjectsPanel_projectNode_select", function(e, projectId)
        {
            const project = ProjectStore.get(projectId);
            const selection = {customerId: project.customerId, projectId: projectId}
            self.actions.changeSingleCPSelectionAction(selection)
        });
        $(document).on("taskManagement_customersProjectsPanel_customerNode_select", function(e, customerId)
        {
            const selection = {customerId: customerId, projectId: null}
            self.actions.changeSingleCPSelectionAction(selection)
        });

        $(document).on("taskManagement_taskTable_taskRow_selectionChange", (e, data) => {
            this.actions.changeTaskSelected(data.taskId, data.isSelected)
        });

        $(document).on("taskManagement_taskTable_selectAllChange", () => {
            this.actions.changeSelectAllTasks()
        });

        $(document).on("taskManagement_tasksTable_addNewTaskMenu_importTasks", function()
        {
            self._showImportTasksPopup();
        });

        $(document).on("taskManagement_viewCustomer", function(e, customerId)
        {
            const prevCustomerId = self.customerPanelController.customerId;

            if (prevCustomerId)
                $(document).trigger("taskManagement_customerViewEnd", prevCustomerId);

            self.actions.openCustomerPanel(customerId)
        });

        $(document).on("taskManagement_customersProjectsPanel_viewProject", function(e, projectId)
        {
            const prevProjectId = self.projectPanelController.projectId;

            if (prevProjectId){
                $(document).trigger("taskManagement_projectViewEnd", prevProjectId);
            }

            self.actions.openProjectPanel(projectId)
        });

        $(document).on('editTaskPanel_updateTask', (e, {taskId}) => this.tasksTable.updateRow(taskId))
    }

    loadTasks(isReload) {
        this._baseLoadTasks(
            isReload,
            "TaskManagementService.getTasks",
            this._getBaseLoadTasksParams(isReload),
            this._loadTasksErrorHandler,
        )
    }

    _getBaseLoadTasksParams(isReload)
    {
        return [
            this.state.intersectedCustomerProjectSelection,
            this.state.taskStatusFilter,
            this.state.taskNameFilter,
            this.state.showOnlyManageableTasks,
            this.state.tasksSorting.by,
            this.state.tasksSorting.asc,
            isReload ? 0 : TaskManagementStore.getTaskIds().length,
            TASK_LOAD_LIMIT,
        ]
    }

    _loadTasksErrorHandler = (jqXHR, textStatus, errorThrown) => {
        switch (errorThrown.exception) {
            case NO_SUCH_PROJECT_EXCEPTION:
                return this.showAlertAndReloadPage("task.list.error.load_tasks.no_such_project")
            case PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
            case PROJECT_IS_NOT_ASSIGNED_EXCEPTION:
                return this.showAlertAndReloadPage("task.list.error.load_tasks.project_not_assigned")
            case NO_SUCH_CUSTOMER_EXCEPTION:
                return this.showAlertAndReloadPage("project.edit.customer_deleted_concurrently")
            case CUSTOMER_UNAVAILABLE_EXCEPTION:
                return this.showAlertAndReloadPage("customer.edit.not_assigned_concurrently")
        }
        return false
    }

    _baseLoadTasks(isReload, serviceName, params, customErrorHandler) {
        $(document).trigger(isReload ? "taskManagement_loadTasks_withReload_begin" : "taskManagement_loadTasks_withAppend_begin")

        if (this.loadTasksRequest)
            this.loadTasksRequest.abort()

        this.loadTasksRequest = makeRpcCall(
            serviceName,
            params,
            (data) => {
                this.actions.setTypesOfWork(data['billingTypes']['list'])

                if (this.state.twsEnabled) {
                    this.actions.setWorkflowStatusesList(data['workflowStatuses'])
                }

                StoreUtils.mergeCustomersProjectsFromRPC(data.customers, data.projects)

                const loadedTasks = _.map(data["tasks"], taskFromRpc)
                TaskManagementStore.setAllTasksLoaded(loadedTasks.length < TASK_LOAD_LIMIT)

                this.actions.addTasks(loadedTasks)

                const taskIds = _.pluck(loadedTasks, "id")
                if (isReload) {
                    this.intersectWithSelectedTasks(taskIds)
                    this.actions.setTasksTableLoaded(true)
                }

                this.actions.setManagementAssignments(data["managementAssignments"])
                this.actions.setHasManageableTasks(data["hasManageableTasks"])

                if (isReload) {
                    TaskManagementStore.replaceTaskIds(taskIds)

                    this.actions.setLoadedTaskIds(taskIds)
                }
                else {
                    TaskManagementStore.appendTaskIds(taskIds)

                    this.actions.addLoadedTaskIds(taskIds)
                }
            },
            (jqXHR, textStatus, errorThrown) => {
                this.actions.setTasksTableLoaded(true)
                if (textStatus === "rpc_customException" && !!customErrorHandler) {
                    return customErrorHandler(jqXHR, textStatus, errorThrown)
                }

                return false
            })
    }

    intersectWithSelectedTasks(taskIds)
    {
        const selectedTaskIds = TaskManagementStore.getSelectedTasks();
        const filteredTaskIds = _.filter(taskIds, function(key)
        {
            return !!selectedTaskIds[key];
        });
        const filteredTaskIdsMap = _.pick(selectedTaskIds, filteredTaskIds);

        TaskManagementStore.setTaskSelection({
            isAllSelected: false,
            selectedTasks: filteredTaskIdsMap,
            countLoading: false,
            count: filteredTaskIds.length
        });
    }

    updateTask(rpcMethod, rpcParams, taskId)
    {
        const self = this;
        const prevTask = TaskStore.get(taskId);
        makeRpcCall(rpcMethod,
                    rpcParams,
                    function(data)
                    {
                        const task = taskFromRpc(data["task"]);
                        const project = projectFromRpc(data["project"]);
                        const customer = customerFromRpc(data["customer"]);

                        self.actions.addTasks([task])

                        // TODO: remove this hot fix(trying to understand what method was called)
                        if (rpcMethod.indexOf("Status") !== -1) {
                            self.actions.changedTaskWorkflowStatus({
                                taskId: taskId,
                                workflowStatusId: task.workflowStatusId,
                                prevWorkflowStatusId: prevTask.workflowStatusId,
                            })
                            toast(messageResource.getMessage("status.tasks.toast.singular", [task.name]));
                        }
                        if (!_.isEqual(ProjectStore.get(task.projectId), project) ||
                            !_.isEqual(CustomerStore.get(project.customerId), customer))
                        {
                            ProjectStore.add(project);
                            self.actions.addProjects([project])
                            CustomerStore.add(customer);
                            self.actions.addCustomers([customer])
                        }

                        $(document).trigger("taskManagement_taskUpdated", task.id);
                    },
                    (jqXHR, textStatus, errorThrown) =>
                    {
                        if (textStatus === "rpc_customException")
                        {
                            switch (errorThrown.exception)
                            {
                                case NO_SUCH_TASK_EXCEPTION:
                                    self.actions.removeTasks([taskId])
                                    alert(messageResource.getMessage("task.error.concurrently_deleted.cannot_edit"));
                                    return true;
                                case TASK_UNAVAILABLE_EXCEPTION:
                                    self.actions.removeTasks([taskId])
                                    alert(messageResource.getMessage("task.list.error.update_task.task_unavailable"));
                                    return true;
                                case TASK_CANNOT_BE_MODIFIED_EXCEPTION:
                                    return super.showAlertAndReloadPage("common.no_rights_for_operation_anymore");
                                case PROJECT_IS_NOT_AVAILABLE_EXCEPTION:
                                    alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                                    ProjectStore.remove(prevTask.projectId);
                                    self.actions.removeProject(prevTask.projectId)
                                    return true;
                                case PROJECT_CANNOT_BE_MODIFIED_EXCEPTION:
                                    alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                                    self._updateAll();
                                    return true;
                                case CUSTOMER_UNAVAILABLE_EXCEPTION:
                                    alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                                    CustomerStore.remove(prevTask.customerId);
                                    self.actions.removeCustomer(prevTask.customerId)
                                    return true;
                                case CUSTOMER_CANNOT_BE_MODIFIED_EXCEPTION:
                                    alert(messageResource.getMessage("common.no_rights_for_operation_anymore"));
                                    self._updateAll();
                                    return true;
                                case TASK_ESTIMATE_DISABLED_EXCEPTION:
                                    return super.showAlertAndReloadPage("task.list.error.estimate_off");
                                case PROJECT_IS_ARCHIVED_EXCEPTION:
                                    // confirm reopening of archived project containing this task
                                    if (confirm(messageResource.getMessage('task.error.reopen.project_archived')))
                                    {
                                        const newRpcParams = rpcParams.slice();
                                        newRpcParams.pop();
                                        newRpcParams.push(true);
                                        self.updateTask(rpcMethod, newRpcParams, taskId);
                                    }
                                    else
                                    {
                                        $(document).trigger("taskManagement_taskUpdated", prevTask.id);
                                    }
                                    return true;
                                case WORKFLOW_STATUS_CHANGED_EXCEPTION:
                                    return super.showAlertAndReloadPage("change_tasks_workflow_status.workflow_status_changed_error");
                                case NO_SUCH_WORKFLOW_STATUSES_EXCEPTION:
                                    return super.showAlertAndReloadPage("change_tasks_workflow_status.no_such_workflow_status_error");
                                case WORKFLOW_STATUSES_FEATURE_BECOME_ENABLED_EXCEPTION:
                                    return super.showAlertAndReloadPage("change_tasks_workflow_status.feature_became_enabled")
                                case WORKFLOW_STATUSES_FEATURE_BECAME_DISABLED_EXCEPTION:
                                    return super.showAlertAndReloadPage("change_tasks_workflow_status.feature_became_disabled")
                            }
                        }

                        return false;
                    });
    }

    _showImportTasksPopup()
    {
        this.loadTasksFromCSVManager.showPopup();
    }

    _onImportFromCsvCompleted(projectIds)
    {
        if (projectIds.length > 0)
        {
            this._updateVisibleCustomersProjectsAfterNewDataLoaded(new CustomerProjectSelection(CustomersProjectsSelectionQualifier.SELECTED, [], projectIds),
                                                                   {customerId: null, projectId: null});
            this._markTaskShortcutIfPresent();
        }
    }

    _showCreateTaskPopup()
    {
        const singleSelection = this.state.singleCustomerProjectSelection
        this.createTasksPopupContorller.showPopup(singleSelection.customerId, singleSelection.projectId, null, true)
    }

    _appendCreatedTasks(result)
    {
        const createdTasks = result["createdTasks"].list;

        // mark shortcuts for tasks
        if (createdTasks.length > 0)
        {
            this._markTaskShortcutIfPresent();
        }

        const createdTaskIds = [];
        const currentSingleCPSelection = this.state.singleCustomerProjectSelection

        const newProjectCreated = !this.state.projects[createdTasks.find(taskInfo => taskInfo.project.id)]
        const affectedProjectsSet = {};
        const affectedCustomersSet = {};
        const tasksIdsInCurrentSelection = [];
        _.forEach(createdTasks, (taskInfo) =>
        {
            const task = taskFromRpc(taskInfo["task"]);
            const project = projectFromRpc(taskInfo["project"]);
            const customer = customerFromRpc(taskInfo["customer"]);

            this.actions.addTasks([task])
            ProjectStore.addFirst(project);
            this.actions.addProjects([project])
            CustomerStore.addFirst(customer);
            this.actions.addCustomers([customer])

            const noNeedToChangeSelection = (_.isNull(currentSingleCPSelection.customerId) || currentSingleCPSelection.customerId === customer.id)
                                            && _.isNull(currentSingleCPSelection.projectId) && !newProjectCreated
                                            || currentSingleCPSelection.customerId === customer.id && currentSingleCPSelection.projectId === project.id
            if (noNeedToChangeSelection)
                tasksIdsInCurrentSelection.push(task.id)

            createdTaskIds.push(task.id);

            affectedProjectsSet[project.id] = true;
            affectedCustomersSet[customer.id] = true;
        });

        const affectedCustomerIds = Object.keys(affectedCustomersSet)
        const affectedProjectIds = Object.keys(affectedProjectsSet)

        const singleSelectionByCreatedTasks = {
            customerId: affectedProjectIds.length === 1 ? createdTasks[0].customer.id : null,
            projectId: affectedProjectIds.length === 1 ? affectedProjectIds[0] : null
        }

        if (_.isEmpty(tasksIdsInCurrentSelection) || affectedProjectIds.length > 1)
        {
            this.actions.changeSingleCPSelectionAction(singleSelectionByCreatedTasks)
            $(TaskManagementStore).one('createdTaskIdsReset', function()
            {
                TaskManagementStore.replaceCreatedTaskIds(createdTaskIds);
            });
        }
        else
        {
            TaskManagementStore.appendCreatedTaskIds(tasksIdsInCurrentSelection);
        }

        toast(createdTasksToast(createdTaskIds, affectedProjectIds, affectedCustomerIds))

        const tasks = createdTasks.map(taskData => ({...taskFromRpc(taskData['task'])}))
        const projects = createdTasks.map(taskData => ({...projectFromRpc(taskData['project'])}))
        const customers = createdTasks.map(taskData => ({...customerFromRpc(taskData['customer'])}))
        this.actions.addNewTasks({
            tasks,
            projects,
            customers
        })

        this.actions.setRecentlyCreatedCustomers(affectedCustomerIds.filter(cId => !this.state.customers[cId]))
        this.actions.setRecentlyCreatedProjects(affectedProjectIds.filter(pId => !this.state.projects[pId]))
    }

    _createProjectSuccess(result)
    {
        const customer = customerFromRpc(result["customer"]);
        CustomerStore.addFirst(customer);
        this.actions.addCustomers([customer])

        const project = projectFromRpc(result["project"]);
        project.archived = false;
        ProjectStore.addFirst(project);
        this.actions.addProjects([project])
        this.actions.setRecentlyCreatedProjects([project.id])

        const createdTaskList = result["tasks"].list;
        if (createdTaskList.length > 0)
        {
            this._markTaskShortcutIfPresent();
        }
        const createdTaskIds = [];
        createdTaskList.forEach(taskInfo => {
            const task = taskFromRpc(taskInfo);
            this.actions.addTasks([task])
            createdTaskIds.push(task.id);
        });

        let newFilterCpSelection = CustomerProjectSelection.fromPlainObject(this.state.filterCustomerProjectSelection)

        const isCreatedProjectCustomerSelected = newFilterCpSelection.includesCustomer(customer);

        if (newFilterCpSelection.qualifier === CustomersProjectsSelectionQualifier.SELECTED && !isCreatedProjectCustomerSelected) {
            newFilterCpSelection = new CustomerProjectSelection(
                CustomersProjectsSelectionQualifier.SELECTED,
                newFilterCpSelection.customers,
                newFilterCpSelection.projects.concat(project.id));
        }
        this._updateVisibleCustomersProjectsAfterNewDataLoaded(newFilterCpSelection, {customerId: customer.id, projectId: project.id});

        toast(messageResource.getMessage("create.project.toast", [project.name]));
        if (CustomerProjectSelection.fromPlainObject(this.state.filterCustomerProjectSelection).includesProject(project)) {
            this.actions.changeSingleCPSelectionAction({customerId: customer.id, projectId: project.id});
        }
    }

    _createProjectFailure(jqXHR, textStatus, errorThrown)
    {
        console.log(errorThrown);
    }

    _showCreateCustomerPopup()
    {
        this.createCustomerPopupController.showPopup();
    }

    _onCreateCustomerSuccess(result)
    {
        // TODO: this piece of code is very similar to handlers for creating projects and tasks from popups

        this.actions.toggleLoadingMoire(false)
        const customer = customerFromRpc(result["customer"]);
        CustomerStore.addFirst(customer);
        this.actions.addCustomers([customer])

        // if tasks copied (aka created) need to check shortcut
        if (result["taskIds"] && result["taskIds"].length > 0)
        {
            this._markTaskShortcutIfPresent();
        }

        if (result["projects"]) {
            const projects = result["projects"].list.map((data) => {
                const p = projectFromRpc(data);
                p.archived = false;
                return p;
            })
            ProjectStore.mergeAll(projects)
            this.actions.addProjects(projects)
        }

        let newFilterCpSelection = CustomerProjectSelection.fromPlainObject(this.state.filterCustomerProjectSelection)
        if (newFilterCpSelection.qualifier === CustomersProjectsSelectionQualifier.SELECTED)
            newFilterCpSelection = new CustomerProjectSelection(CustomersProjectsSelectionQualifier.SELECTED,
                newFilterCpSelection.customers.concat(customer.id),
                newFilterCpSelection.projects);
        this._updateVisibleCustomersProjectsAfterNewDataLoaded(newFilterCpSelection,
            {customerId: customer.id, projectId: null});
        this.actions.setRecentlyCreatedCustomers([customer.id])

        toast(messageResource.getMessage("create.customer.toast", [customer.name]));
        if (CustomerProjectSelection.fromPlainObject(this.state.filterCustomerProjectSelection).includesCustomer(customer))
            this.actions.changeSingleCPSelectionAction({customerId: customer.id, projectId: null})
    }

    _showCreateProjectPopup()
    {
        const singleSelection = this.state.singleCustomerProjectSelection
        const customerId = (!_.isNull(singleSelection.customerId)) ? singleSelection.customerId : null;

        this.createProjectPopupController.showPopup(customerId)
    }

    _updateVisibleCustomersProjectsAfterNewDataLoaded(newFilterCpSelection, newSingleCpSelection)
    {
        this.actions.changeCPSelection(newSingleCpSelection, newFilterCpSelection.toPlainObject())
    }

    _updateAll()
    {
        // need to reload all view modes
        this.actions.setTasksTableLoaded(false)
        this.actions.setKanbanLoaded(false)
    }

    _triggerTaskEdited(taskId)
    {
        TaskManagementStore.setTaskIdInEdit(null);
        $(document).trigger('taskManagement_task_stopEditing', taskId);
    }

    _triggerTaskUpdated(taskId)
    {
        $(document).trigger('taskManagement_task_updated_in_panel', taskId);
    }

    _handleCustomerArchived(customer) {
        this.actions.archiveProjectsOfCustomer(customer.id)
        this.tasksTable.updateRows();
    }

    _markTaskShortcutIfPresent()
    {
        // mark on client that task(s) will be created and show just checked shortcut
        if (!_.isUndefined(window.GettingStartedShortcuts))
        {
            window.GettingStartedShortcuts.markShortcutAsChecked(window.GettingStartedShortcut.TASKS);
            window.GettingStartedShortcuts.showJustCheckedShortcutIfExists();
        }
    }

    _updateViewMode(viewMode) {
        this.tasksTable.toggle(viewMode === TaskManagementViewMode.TABLE);
        this.kanbanViewContainer.toggle(viewMode === TaskManagementViewMode.KANBAN);
    }
}

export default connect(
    state => ({
        viewMode: getViewMode(state),
        selectedTaskIds: getSelectedTaskIds(state),
        showLoadingMoire: isShowLoadingMoire(state),
        bulkOperationProgress: getBulkOperationProgress(state),
        filterCustomerProjectSelection: getFilterCPSelection(state),
        singleCustomerProjectSelection: getSingleCPSelection(state),
        intersectedCustomerProjectSelection: getIntersectedCPSelection(state),
        taskNameFilter: getTaskNameFilter(state),
        taskStatusFilter: getTaskStatusFilter(state),
        workflowStatusesMap: getWorkflowStatuses(state),
        tasksSorting: getTasksSorting(state),
        isNeedToReloadTableTasks: isNeedToReloadTableTasks(state),
        taskIdWithDetailsOpen: getOpenTaskId(state),
        showOnlyManageableTasks: isShowOnlyManageableTasks(state),
        loggedInUser: getLoggedInUser(state),
        twsEnabled: isTWSEnabled(state),
        isWASEnabled: isWASEnabled(state),
        projects: getProjects(state),
        customers: getCustomers(state),
        isPossibleToAddTasks: isPossibleToAddTasks(state),
    }),
    dispatch => ({
        openTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
        openProjectPanel: bindActionCreators(openProjectPanel, dispatch),
        openCustomerPanel: bindActionCreators(openCustomerPanel, dispatch),
        changeSelectAllTasks: bindActionCreators(changeAllTasksSelectedAction, dispatch),
        changeTaskSelected: bindActionCreators(changeTaskSelected, dispatch),
        changeTaskNameFilterAction: bindActionCreators(changeTaskNameFilterAction, dispatch),
        addNewTasks: bindActionCreators(addNewTasks, dispatch),
        addCustomers: bindActionCreators(addCustomers, dispatch),
        addProjects: bindActionCreators(addProjects, dispatch),
        addTasks: bindActionCreators(addTasks, dispatch),
        setTypesOfWork: bindActionCreators(setTypesOfWorkList, dispatch),
        removeTasks: bindActionCreators(removeTasks, dispatch),
        removeProject: bindActionCreators(removeProject, dispatch),
        removeCustomer: bindActionCreators(removeCustomer, dispatch),
        changeSingleCPSelectionAction: bindActionCreators(changeSingleCPSelectionAction, dispatch),
        changeCPSelection: bindActionCreators(changeCPSelection, dispatch),
        setTasksTableLoaded: bindActionCreators(setTasksTableLoaded, dispatch),
        setKanbanLoaded: bindActionCreators(setKanbanLoaded, dispatch),
        setManagementAssignments: bindActionCreators(setManagementAssignments, dispatch),
        setViewerSettings: bindActionCreators(setViewerSettings, dispatch),
        setHasManageableTasks: bindActionCreators(setHasManageableTasks, dispatch),
        setRecentlyCreatedCustomers: bindActionCreators(setRecentlyCreatedCustomers, dispatch),
        setRecentlyCreatedProjects: bindActionCreators(setRecentlyCreatedProjects, dispatch),
        setWorkflowStatusesList: bindActionCreators(setWorkflowStatusesList, dispatch),
        copyTasksToProjectsAction: bindActionCreators(copyTasksToProjectsAction, dispatch),
        archiveProjectsOfCustomer: bindActionCreators(archiveProjectsOfCustomerAndReloadTasks, dispatch),
        archiveProject: bindActionCreators(archiveProjectAndReloadTasks, dispatch),
        changedTaskWorkflowStatus: bindActionCreators(changedTaskWorkflowStatus, dispatch),
        setLoadedTaskIds: bindActionCreators(setLoadedTaskIds, dispatch),
        addLoadedTaskIds: bindActionCreators(addLoadedTaskIds, dispatch),
        toggleLoadingMoire: bindActionCreators(toggleLoadingMoire, dispatch),
        updateEnabledFeatures: bindActionCreators(setEnabledFeatures, dispatch),
    })
)(TaskManagementMediator)


// WEBPACK FOOTER //
// ./web/js/taskManagement/Mediator.js